import React from "react";
import { Plus, Clock } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";
import { useCart } from "../context/CartContext";
import { EXPERIENCES } from "../mock";
import SectionHeader from "./SectionHeader";
import useReveal from "../hooks/useReveal";
import { Button } from "./ui/button";

export default function Experiences() {
  const { t, S, lang } = useLang();
  const { addItem } = useCart();
  const ref = useReveal();

  const add = (ex) => {
    addItem({
      id: ex.id,
      type: "experience",
      name: ex.name,
      subtitle: ex.duration,
      price: ex.price,
      img: ex.img,
    });
    toast.success(t(S.added), { description: ex.name[lang] });
  };

  return (
    <section id="experiencias" ref={ref} className="py-20 md:py-28 section-tint">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeader kicker={t(S.experiences.kicker)} title={t(S.experiences.title)} sub={t(S.experiences.sub)} />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {EXPERIENCES.map((ex, i) => (
            <div
              key={ex.id}
              className="group card-lift reveal bg-white rounded-2xl overflow-hidden border border-border shadow-sm flex flex-col"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={ex.img} alt={t(ex.name)} className="w-full h-full object-cover img-zoom" />
                <span className="absolute top-4 right-4 flex items-center gap-1.5 text-xs font-semibold text-white bg-primary/85 backdrop-blur px-3 py-1.5 rounded-full">
                  <Clock className="w-3.5 h-3.5" />
                  {t(ex.duration)}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display font-bold text-lg text-foreground">{t(ex.name)}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed flex-1">{t(ex.desc)}</p>
                <div className="mt-5 flex items-end justify-between">
                  <div>
                    <div className="font-display font-extrabold text-2xl text-primary">
                      ${ex.price}
                      <span className="text-sm text-muted-foreground font-sans font-medium ml-1">USD</span>
                    </div>
                    <div className="text-xs text-muted-foreground">{t(S.experiences.perPerson)}</div>
                  </div>
                  <Button
                    onClick={() => add(ex)}
                    className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold rounded-full"
                  >
                    <Plus className="w-4 h-4" />
                    {t(S.transfers.add)}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
